import { useTheme as useMuiTheme } from '@mui/material';

import { BAITheme } from '@bai/utils/types';

export function useTheme() {
  return useMuiTheme<BAITheme>();
}
